<template>
  <v-menu
    v-model="menu_ativo"
    open-on-hover
    left
    offset-y
    transition="slide-y-transition"
    open-delay="500"
    close-delay="500"
    close-on-click
    :close-on-content-click="false"
  >
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon @click.stop>
        <v-icon>$BatteryPlus</v-icon>
      </v-btn>
    </template>

    <div class="bg-white font-12">
      <div class="px-3 pb-1 pt-2 d-flex align-center">
        <v-icon small>mdi-alert</v-icon>
        <span class="font-weight-medium font-13 pl-1">Alerta</span>

        <v-spacer />

        <v-btn icon x-small @click="menu_ativo = false">
          <v-icon size="16">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider />

      <div class="px-3 pb-3">
        <p class="mt-2 mb-0">
          Este produto possui uma venda futura de {{ formatarValor(quantidade_venda_futura) }}.
        </p>

        <p class="mt-2 mb-1  font-weight-medium">
          Você gostaria de adquirir essa quantidade?
        </p>

        <div>
          <span>
            Sim, comprar a necessidade({{ formatarValor(quantidade_sugestao)}})
            mais a venda futura({{ formatarValor(quantidade_venda_futura)}})
          </span>

          <v-btn
            x-small
            rounded
            color="#043554"
            dark
            class="ml-2"
            @click="aplicarValor(Number(quantidade_sugestao) + Number(quantidade_venda_futura))"
          >
            aplicar
          </v-btn>
        </div>

        <div v-if="Number(quantidade_sugestao) > 0" class="mt-1">
          <span>Não, comprar apenas a necessidade({{ formatarValor(quantidade_sugestao)}})</span>

          <v-btn x-small rounded color="#043554" dark class="ml-2" @click="aplicarValor(quantidade_sugestao)">
            aplicar
          </v-btn>
        </div>

        <div v-if="Number(quantidade_compra) !== Number(quantidade_sugestao)" class="mt-1">
          <span>Não, comprar diferente da sugestão({{ formatarValor(quantidade_compra)}})</span>

          <v-btn x-small rounded color="orange" dark class="ml-2" @click="aplicarValor(quantidade_compra)">
            aplicar
          </v-btn>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script>
import {validarVendaFutura} from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/utils";
import {formatarValor} from "@/helpers";

export default {
  name: "ValidacaoSugestaoVendaFutura",
  emits: ['aplicar-valor'],
  props: {
    quantidade_compra: Number,
    quantidade_sugestao: Number,
    quantidade_venda_futura: Number,
  },
  data: () => ({
    menu_ativo: false,
  }),
  methods: {
    validarVendaFutura,
    formatarValor,
    aplicarValor(valor) {
      this.$emit('aplicar-valor', valor);
    }
  }
}
</script>
